import { render, staticRenderFns } from "./CruiseDetailIntroduction.vue?vue&type=template&id=202e9fda&scoped=true&"
import script from "./CruiseDetailIntroduction.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./CruiseDetailIntroduction.vue?vue&type=style&index=0&id=202e9fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e9fda",
  null
  
)

export default component.exports